import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {FinancialFilingYearContainerModel} from '../../../../../../models/aggregates/erp/financial-filing';
import {Core2Config} from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class FinancialFilingYearService extends BaseApiTemplateService<FinancialFilingYearContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'filing-years/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'filing-years/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'filing-years/backoffice-ep';
    this.httpClient = http;
  }

}


